module.exports = __webpack_public_path__ + "static/media/2023-VC-Feature-Banner-Desktop@1x.6c80b3ed.jpg";